// @flow
import * as React from "react";
import cx from "classnames";
import { format } from "date-fns";
import { formatCurrency, timeLabelSinceDate } from "buba-components/src/utils/formatters";
import Card from "../Card";
import sharedStyles from "../DashboardSummary/shared/Shared.scss";
import LabeledContent from "../DashboardSummary/LabeledContent";
import { statuses } from "../../data/statuses";

import styles from "./SummarySection.scss";

type SummarySectionProps = {
  title: string,
  id: string,
  status: string,
  createdAtDate: Date,
  volume?: string,
  channel?: string,
  level?: string,
  isBubaPortal?: boolean
};

// 2. Format as "DD.MM.YYYY"
export function formatDateDDMMYYYY(date) {
  return format(date, "dd.MM.yyyy");
}

// 3. Format as "HH:MM"
export function formatDateHHMM(date) {
  return format(date, "HH:mm");
}

const SummarySection = ({
  title,
  id,
  status,
  createdAtDate,
  volume,
  channel,
  level,
  isBubaPortal = false
}: SummarySectionProps) => {
  const channelLabel = {
    bankFinancingRequest: "Direktanfrage",
    bapiFinancingRequest: "OSPlus",
    okpFinancingRequest: "OKP"
  };

  const relevantStatuses = isBubaPortal ? statuses.bubaBankAdvisor : statuses.bank;

  return (
    <Card additionalCardStyles={styles.summaryCard}>
      <h1 className={cx(styles.title, sharedStyles.borderBottom)}>{title}</h1>
      <div className={sharedStyles.row}>
        <div className={sharedStyles.col}>
          <LabeledContent label="ID">{id}</LabeledContent>
        </div>
        <div className={sharedStyles.col}>
          <LabeledContent label="Status">{relevantStatuses[status]?.label}</LabeledContent>
        </div>
        <div className={sharedStyles.col}>
          <LabeledContent label="Alter">{timeLabelSinceDate(createdAtDate)}</LabeledContent>
        </div>
        <div className={sharedStyles.col}>
          <LabeledContent label="Erstellt am">
            {formatDateDDMMYYYY(createdAtDate)}
            <br />
            {`${formatDateHHMM(createdAtDate)} Uhr`}
          </LabeledContent>
        </div>
        {volume && (
          <div className={sharedStyles.col}>
            <LabeledContent label="Volumen">{formatCurrency(volume)}</LabeledContent>
          </div>
        )}
        {channelLabel[channel] && (
          <div className={sharedStyles.col}>
            <LabeledContent label="Eingangskanal">{channelLabel[channel]}</LabeledContent>
          </div>
        )}
        {level && (
          <div className={sharedStyles.col}>
            <LabeledContent label="Anfragelevel">{level}</LabeledContent>
          </div>
        )}
      </div>
    </Card>
  );
};

SummarySection.defaultProps = {
  title: "",
  id: "",
  status: "",
  createdAtDate: null,
  volume: ""
};

export default SummarySection;
